export default {
  //我的
  'user.login.register': '登录 / 注册',
  'user.item1': '帮助中心',
  'user.item2': '通用设置',
  'user.item3': '安全设置',
  'user.item4': '关于我们',
  'user.item5': '联系我们',
  'user.logout': '退出登录',
  'user.index.mine': '我的',
  'user.index.assets': '资产',

  //关于我们
  'footer.contact.item1': '客服微信：',
  'footer.contact.item2': '商务合作：',
  'user.aboutUs.title': '关于我们',
  'user.aboutUs.desc1': 'WBroker成立于2017年，所属公司是在新西兰登记注册的金融服务提供商，持有澳大利亚ASIC经纪牌照、新西兰FSPR经纪牌照等，致力于为全球客户提供股票、融资等投资服务。',
  'user.aboutUs.desc2': 'WBroker始终将客户的资金安全、投资风险视为首要责任，将“简单•安全”做到极致，为用户提供最安全可靠、简单易用的金融服务。',
  'user.aboutUs.desc3': 'WBroker始终关注各层次人群的需求，支持男女平等、关注贫困地区儿童和女性弱势群体，并一直在为创造一个“所有弱势群体均有机会参与及分享金融红利”的梦想而努力。',

  //错误吗
  'error.999991': '参数错误',
  'user.tryAgainLater': '请稍后再试',
  'user.accountExist': '账号已经存在',
  'user.codeError': '验证码不匹配',
  'user.amountMoreRate': '出金金额要求大于手续费',
  'user.assetNotEnough': '资金不足',
  'user.code039992': '当前存在申购单,不可提现',
  'user.code039993': '存在未扣款的提现,请稍后',
  'user.code039994': '资产获取失败',
  'user.code019111': '人像面不清晰，请重新上传',
  'user.code019112': '国徽面不清晰，请重新上传',
  'user.code019115': '图片模糊，请手动填写信息',
  'user.code019116': '图片不匹配',
  'user.code170001': '此信托当前不允许申购',
  'user.code170002': '申购金额小于最低申购标准',
  'user.code170004': '此信托当前不允许赎回',
  'user.code170005': '持仓不足',
  'user.code170006': '存在可申购新股，不可申购和赎回',
  'user.code199921': '您已加入委托计划，暂不能做此操作',
  'user.code019991': '验证码错误',
  'user.code019992': '验证码不匹配',
  'user.code009995': '该邮箱已经被绑定',
  'user.code009991': '账号不存在',
  'user.code009992': '密码错误',
  'user.code009993': '账号重复',
  'user.code019990': '短讯发送错误',
  'user.code029992': '对手订单已被抢购',
  'user.code009997': '姓名身份证不匹配',
  'user.code009998': '身份证已被其他账号绑定',
  'user.code019999': '此账号已开户',
  'user.code020002': '您的年龄暂不能在平台开户',
  'user.code020003': '身份证校验失败,请联系客服',
  'user.code019119': '身份证已过有效期',
  'user.code019120': '证件已过有效期',
  'user.code020011': '填写信息与图片中信息不一致',
  'user.code009980': '暂不支持此域名邮箱，请更换',
  'user.code019130': '您的账号异常，已被封号',
  'user.code010002': '存在未完成的借贷',
  'user.code010001': '借贷异常,请联系客服',
  'user.code039777': '驳回次数超过当日限制',
  'user.code023010': '扣款失败',
  'user.code577220398': '该新股总融资金额已超出公司融资额度',
  'message.error.199678': '已超过绑定期限',
  'message.error.199668': '邀请码有误',
  'message.error.199679': '邀请码已存在',
  'message.error.199669': '不可填写注册时间晚于自己的用户邀请码',
  'setting.email.error': '邮箱参数异常',
  'setting.email.code.error': '当前绑定邮箱验证码错误',
  'setting.new.email.error': '新邮箱验证码错误',
  'setting.mobile.error': '手机参数异常',
  'setting.mobile.code.error': '当前绑定手机验证码验证错误',
  'setting.new.mobile.error': '新手机验证码校验错误',
  'setting.txPassword.error': '交易密码错误',
  'setting.new.txPassword.error': '交易密码不能与当前密码一样',
  'setting.password.error': '登录密码校验错误',
  'setting.new.password.error': '登录密码不能与前三次修改记录一样',
  'setting.face.error': '人脸信息校验错误',
  'setting.error039930': '未获取到安全校验配置',
  'setting.error039931': '邮箱验证码错误',
  'setting.error039932': '手机验证码错误',
  'setting.error039935': '校验手机或者邮箱错误',
  'message.error.030061': '手机已被绑定，请修改手机后重新操作',
  'message.error.030060': '邮箱已被绑定，请修改邮箱后重新操作',
  'user.TransactionPasswordError': '交易密码校验失败',
  'message.error.7020': '帐户不存在',

  //个人中心
  'user.personalInformation': '绑定手机',
  'user.personalInformation2': '绑定邮箱',
  'user.uploadInfo.personalInformation': '个人信息',
  'user.userInfo.title': '账户',
  'user.name': '姓名',
  'user.certificateType': '证件类型',
  'user.mainlandID': '大陆身份证',
  'user.passport': '护照',
  'user.hongKongID': '香港身份证',
  'user.otherID': '其他证件',
  'user.idNumber': '证件号码',
  'user.customerNo': '用户号',
  'user.accountStatus': '开户状态',
  'user.hasNotOpenAccount': '未开户',
  'user.accountApproving': '资料审核中',
  'user.hasOpen': '已开户',
  'user.frozen': '已冻结',
  'user.rejectApprove': '审核驳回',
  'user.accountCancellation': '已注销',
  'user.inactivated': '未激活',
  'user.unknownStatus': '未知状态',

  //帮助中心
  'helpCenter.header': '欢迎来到帮助中心',
  'user.help.search': '搜索',
  'help.search.result1': '搜索到与“',
  'help.search.result2': '“相关结果共',
  'help.search.result3': '条',
  //搜索到与“${XXX}“相关结果共${5}条
  'user.help.desc': '如果下列回答不能帮助到您, 您可以联系',
  'user.help.desc.onlineServer': '在线客服',
  'user.help.desc.last': ' ',
  //如果下列回答不能帮助到您, 您可以联系在线客服
  'user.help.more': '更多',
  'help.relate.title': '相关问题',

  //通用设置
  'user.language': '语言',
  'user.english': '英文',
  'user.simplifiedChinese': '简体中文',
  'user.upDownColor': '涨跌色',
  'user.upRedDownGreen': '红涨绿跌',
  'user.upGreenDownRed': '绿涨红跌',

  //安全设置
  'user.modifyLoginPassword': '修改登录密码',
  'user.change.trcPsw': '修改交易密码',
  'user.email': '邮箱',
  'user.mobile': '手机号',
  'user.change.withdraw': '出金管理',
  'setting.go.to.bind': '去绑定',
  'user.ok': '确认',
  'user.verifyMobile': '验证当前绑定手机',
  'user.form.mobileCodeHash.placeholder': '请输入手机验证码',
  'user.getVerifyCode': '获取验证码',
  'user.verifyEmail': '验证当前绑定邮箱',
  'user.emailCodeHash.placeholder': '请输入邮箱验证码',
  'user.transactionPassword': '交易密码',
  'user.finishTransactionPsw': '请输入交易密码',
  'user.loginPsw.label': '登录密码',
  'user.loginPsw.placeholder': '请输入登录密码',
  'user.new.bind.phone': '新绑定手机号',
  'user.new.bind.phone.placeholder': '请输入新绑定手机号',
  'user.verifyCode': '验证码',
  'user.pleaseFinishVerifyCode': '请输入验证码',
  'user.new.bind.email': '新绑定邮箱',
  'user.new.bind.email.placeholder': '请输入新绑定邮箱',
  'user.current.loginPsw': '原登录密码',
  'user.current.loginPsw.placeholder': '请输入原登录密码',
  'user.new.loginPsw': '设置新登录密码',
  'user.new.loginPsw.placeholder': '请输入8-12位字母、数字组合密码',
  'user.repeat.new.loginPsw': '重复输入新登录密码',
  'user.new.trans.psw': '设置新交易密码',
  'user.new.trans.psw.again': '请再次确认交易密码',
  'user.new.txPsw': '请输入6位数字作为新的交易密码',
  'user.emailRuleError': '邮箱格式有误',
  'user.new.trans.psw.conform': '确认交易密码',
  'newSetting.mobile.tip1': '*请您注意，您正在操作修改手机号，修改',
  'newSetting.mobile.tip1.1': '小时后才可出金；',
  'newSetting.mobile.tip2': '*修改后将使用新绑定手机号登录及找回密码；',
  'newSetting.bindMobile.tip1': '*请您注意，您正在操作绑定手机号，绑定',
  'newSetting.bindMobile.tip1.1': '小时后才可出金；',
  'newSetting.email.tip1': '*请您注意，您正在操作修改邮箱，修改',
  'newSetting.email.tip1.1': '小时后才可出金；',
  'newSetting.email.tip2': '*修改后将使用新绑定邮箱登录及找回密码；',
  'newSetting.bindEmail.tip1': '*请您注意，您正在操作绑定邮箱，绑定',
  'newSetting.bindEmail.tip1.1': '小时后才可出金；',
  'newSetting.password.tip1': '*请您注意，您正在操作修改登录密码；',
  'newSetting.txPassword.tip1': '*请您注意，您正在操作修改交易密码，修改',
  'newSetting.txPassword.tip1.1': '小时后才可出金；',
  'newSetting.txPassword.tip2': '*请牢记此密码，涉及交易和资金等影响账户安全的操作，都需要校验交易密码；',
  'newSetting.tip1': "*如您收不到验证码或忘记信息，请",
  'newSetting.tip2': "联系客服",
  'newSetting.tip3': "处理。",
  'user.withdraw.management': '出金管理',
  'user.withdraw.address.auth': '出金地址认证',
  'asset.chainType4': 'TRC20(TRON,波场)',
  'asset.chainType1': 'ERC20(ETH,以太坊)',
  'asset.chainType2': 'OMNI(BTC,比特币)',
  'withdraw.address.remark': '备注：',
  'withdraw.address.modify': '修改',
  'withdraw.address.unBind': '解绑',
  'withdraw.bind.address': '+绑定出金地址',
  'confirm.unBind.tip1': '解绑将从列表移除，是否解绑?',
  'bindAddress.button2': '立即认证',
  'asset.currency': '币种',
  'user.bindAddress.chainType': '链名称',
  'bindAddress.address.label': '出金地址',
  'bindAddress.address.placeholder': '请输入出金地址',
  'bindAddress.address.error': '地址格式不正确',
  'bindAddress.remark': '备注  (选填)',
  'bindAddress.remark.placeholder': '备注选填',
  'bindAddress.password': '交易密码',
  'user.form.mobileCodeHash': '手机验证码',
  'user.emailCodeHash': '邮箱验证码',
  'withdraww.bindAddess.tip1': '请您注意，您正在操作出金地址实名认证，认证',
  'withdraww.bindAddess.tip1.1': '小时后才可出金；',
  'user.hasModifyLoginPsw': '登录密码已修改',
  'user.hasModifyTransactionPsw': '交易密码已修改',
  'user.hasModifyEmail': '邮箱已修改',
  'user.hasBindEmail': '邮箱已绑定',
  'user.hasBindMobile': '手机已绑定',
  'user.hasModifyMobile': '手机号已修改',
  'user.back': '返回',
  'user.modifyMobile': '修改手机',
  'user.modifyEmail': '修改邮箱',
  'user.bandEmail': '绑定邮箱',
  'user.bind.phone': '绑定手机号',
  'user.bind.address.title': '绑定出金地址',
  'user.bind.address.success': '出金地址已绑定',

  //联系我们
  'user.contact.title': '添加客服微信，享受专属服务',
  'user.contact.save': '保存图片',
  'user.contact1': '微信客服1:',
  'user.contact2': '微信客服2:',
  'user.contact.email': '客服邮箱:',
  'user.contact.mobile': '客服电话:',
  'user.contactUsTips': '客服办公时间工作日08:30-18:30，非工作时间请留言',

  //登陆注册
  'user.getVerifyCodeFirst': '请先获取验证码',
  'user.login': '登录',
  'user.pleaseFinishPhoneNumber': '请输入手机号',
  'user.pleaseFinishEmail': '请输入邮箱',
  'user.forgetPassword': '忘记密码',
  'user.password': '密码',
  'user.password.placeholder': '请输入密码',
  'user.no.account.tip1': '没有账号请',
  'user.no.account.tip2': '注册',
  'user.form.login.email': '邮箱登录',
  'user.form.login.mobile': '手机登录',
  'login.tip1': '注册或登录即代表已阅读并同意',
  'login.tip2': '服务协议',
  'login.tip3': '和',
  'login.tip4': '隐私政策',
  'user.sign.up': '注册',
  'user.nextStep': '下一步',
  'user.form.register.mobile': '手机注册',
  'user.form.register.email': '邮箱注册',
  'user.has.account.tip1': '已有账号请',
  'user.has.account.tip2': '登录',
  'message.send.code.success': '发送成功',
  'login.password.format.placeholder': '8-12位字母、数字组合密码',
  'user.new.loginPsw.tip1': '8-12位字符',
  'user.new.loginPsw.tip2': '包含字母',
  'user.new.loginPsw.tip3': '包含数字',

  'form.search.address': '搜索国家/区号',
  'form.search.title': '国家/区号',
  'form.search.input': '搜索',
  'user.cancel': '取消',
  'user.login.authentication': '登录验证',
  'asset.beginTime': '开始时间',
  'asset.endTime': '结束时间',
  'asset.finance.page.noData': '暂无数据',

  'user.emailFind': '邮箱找回',
  'user.mobileFind': '手机找回',
  'forget.verifyEmail': '验证邮箱',
  'forget.verifyMobile': '验证手机',
  'forget.transactionPassword': '交易密码',
  'forget.new.password': '新登录密码',
  'forget.confirm.password': '确认新密码',

  'face.liveFace': '人脸识别',
  'face.click.camera': '点击相机图标，进行人脸识别',
  'face.check.success': '人脸识别成功',
  'face.check.fail': '人脸识别失败',
  'face.action0': '眨眼',
  'face.action4': '抬头',
  'face.action5': '低头',
  'face.action7': '左右转头',
  'face.errer.tips': '活体未通过,已刷新动作，请重新录制视频',
  'face.ation.title': '实名认证',
  'face.ation.second.title': '请按下方要求完成视频录制',
  'face.first.ation': '动作一',
  'face.second.ation': '动作二',
  'face.ation.refresh': '刷新动作',
  'face.ation.tip.title': '温馨提示：',
  'face.ation.tip1': '保持环境安静，光线充足',
  'face.ation.tip2': '面部清晰完整',
  'face.ation.tip3': '按要求顺序做标准动作',
  'face.ation.tip4': '拍摄3-5秒的视频',
  'face.ation.btn': '开始录制',
  'face.ation.btn.end': '结束录制',
  'face.ation.btn.restart': '重新录制',
  'face.ation.btn.finish': '完成',

  'notification.title': '通知消息',
  'noMore.data': '暂无更多数据',

  //开户
  'v3.menu.share.open.add.info': '信息补充',
  'form.account.address.title': '开户证件所属地区',
  'form.account.type': '开户证件类型',
  'form.account.type1': '大陆身份证',
  'form.account.type2': '香港身份证',
  'trs.first.passport': '护照',
  'form.account.type9': '本地身份证',
  'account.open.has.idNumber': '该证件号已存在',
  'form.account.name.upload.click.front': '上传人像面',
  'form.account.name.upload.click.back': '上传国徽面',
  'form.account.phone.tip': '拍摄提示',
  'menu.name.zh.cn': '姓名(中文)',
  'menu.name.zh.placeholder': '请填写真实姓名,示例：张三',
  'menu.name.zh.first': '姓(拼音)',
  'menu.name.zh.first.placeholder': '示例：ZHANG',
  'menu.name.zh.second': '名(拼音)',
  'menu.name.zh.second.placeholder': '示例：SAN',
  'form.asset.withdraw.placeholder.input': '请输入',
  'user.country': '国籍',
  'user.tax.country': '报税地区',
  'user.birthday': '出生日期',
  'user.birthday.placeholder': '请选择出生日期',
  'user.date.choose': '请选择日期',
  'user.experied.date': '有效期截止',
  'user.experied.placeholder': '请选择证件有效期',
  'user.experied.long.term': '长期有效',
  'form.user.safe.name.prefix.card.number': '证件号码',
  'form.user.safe.name.placeholder.input.id': '请输入证件号码',
  'account.real.name.explain.first': '1、根据监管要求，投资前您需要完成开户流程，填写相关资料评估是否符合投资者要求。',
  'account.real.name.explain.two': '2、投资证券或金融产品存在潜在的亏损可能，投资者在进行投资前需考虑自身的投资目标及风险承受能力。',
  'face.finish.tip': '请先完成人脸认证',
  'v3.menu.share.open.title': 'WBroker开户',
  'form.account.openMarket.title': '将为您开通的市场类型',
  'form.stock.hk': '港股',
  'form.stock.us': '美股',
  'form.stock.zht': '中华通',
  'form.account.risk': '风险披露',
  'form.account.risk.standar': '持牌代表：',
  'asset.account.open.audio.txt1': '您好，我是吴梦瑶，是WBroker的持牌代表，现在我简单为您说明一下风险披露中的几个要点：',
  'asset.account.open.audio.txt2': '1. 投资者因应自身的投资经验，投资目的，经济收支与相关状况审慎选择与投资风险偏好、与投资需求相应的投资产品或服务。买卖证券具有风险，证券价格可升可跌，有时可能会非常波动，甚至变成毫无价值。',
  'asset.account.open.audio.txt3': '2. 买卖衍生工具涉及高风险，并非每个投资者都适合。投资者需注意，一般而言，衍生产品的流通量较低，价格的波动比较大，也会受相关资产的价格或其公司行动或其他因素（如时间值）的影响而调整，提早解除相关衍生产品合约会比较困难和成本较高。若干衍生产品会有固定的有效日期，到期后可能会变得没有价值，也有被强制收回的风险。',
  'asset.account.open.audio.txt4': '3. 投资者无论是否美国公民或永久居民，只要以个人名义持有这些投资产品，均须缴付税项。所有持有任何形式美国证券的人士均须就所得红利支付预扣税。投资者应留意海外投资涉及的税务问题，并视乎情况寻求专业税务意见。由于美股最低交易单位为 1股，投资者须留意交易佣金可能比交易金额为高。当指令执行后，投资必须缴付相关佣金及收费，佣金及收费的更新通知会不时透过本公司网页或其他途径发布。美股交易受美国证监会严格监管,并不在香港证监会的监管之内。',
  'asset.account.open.audio.txt5': ' 4. 作为客户您需要自行承担电子交易中可能产生的相关风险。 风险说明到此为止，请完成剩下的开户流程，如果您有任何问题，请随时联系我们！谢谢！',
  'user.forth.tip1': '当您点击',
  'user.forth.tip2': '“已阅读”',
  'user.forth.tip3': '按钮，表示您已阅读并了解上述风险',
  //当您点击${“已阅读”}按钮，表示您已阅读并了解上述风险
  'user.forth.btn': '已阅读',
  'trs.tenth.tip2': '请先完成签署协议',
  'open.account.file.title': '签署协议',
  'open.account.file.desc': '本人已详细阅读并同意签署以下所有开户文件',
  'open.account.file.title2': '个人声明',
  'account.open.agrement.check.hkLetter.file': '《香港投资者识别码制度-个人客户同意函》',
  'account.open.agrement.check.customer.file': '《客户协议书》',
  'account.open.agrement.check.risk': '《风险披露》',
  'account.open.agrement.check.no.usa': '《W-8Ben非美国人免税表格》',
  'account.open.agrement.check.commitment': '《投资者承诺书》',
  'account.open.agrement.check1': '本人是该证券账户的最终且唯一受益人',
  'account.open.agrement.check2': '本人与本证券公司的董事和雇员没有任何关系',
  'account.open.agrement.check3': '本人不是任何交易所，证券公司，或其他金融机构的持牌人，雇员，董事，高管',
  'account.open.agrement.check4': '本人没有担任任何重要公职，例如政府机关，军队，国有机构的重要岗位',
  'account.open.agrement.check5': '本人不是美国永久居民(绿卡持有者)',
  'account.open.sign.alert': '请完成手写签名',
  'account.open.sign.title': '手写签名',
  'account.open.sign.desc': '请确保您的手写签名与开户本人姓名保持一致。',
  'account.open.sign.reset': '重写',
  'account.open.setPsw.title': '设置初始交易密码',
  'account.open.setPsw.title.confirm': '请再次确认交易密码',
  'account.open.setPsw.tip': '请输入6位数字',
  'account.open.setPsw.error': '密码不一致，请重新输入',
  'account.open.setPsw.bottom.tip': '*请牢记次密码，涉及交易和资金等影响账户安全的操作，都需要校验交易密码',
  'stock.approving': '开户审核中',
  'account.open.end.notice1': '您的申请资料已提交审核，预计一小时内完成审核并开户',
  'form.asset.withdraw.placeholder.select': '请选择',
  'form.account.house.has': '拥有',
  'form.account.house.use': '租用',
  'form.account.house.with': '与亲戚同住',
  'form.account.stepGrray1': '0年',
  'form.account.stepGrray2': '1年-3年',
  'form.account.stepGrray3': '3年-10年',
  'form.account.stepGrray4': '>10年',
  'form.account.stepGrrayChildren1': '股票、债券及其他证券',
  'form.account.stepGrrayChildren2': '杠杆外汇',
  'form.account.stepGrrayChildren3': '贵重金属',
  'form.account.stepGrrayChildren4': '期货/期权',
  'form.account.stepHrray1': '了解',
  'form.account.stepHrray2': '不了解',
  'form.account.stepHrrayChildren1': '拥有曾买卖衍生产品的经验',
  'form.account.stepHrrayChildren2': '曾接受有关衍生产品的培训或修读相关课程',
  'form.account.stepHrrayChildren3': '拥有涉及衍生工具的工作经验',
  'form.account.choose.houseStatus': '请选择住房情况',
  'form.account.houseStatus.value': '请输入估值',
  'form.account.houseStatus.number': '房屋估值只能输入数字',
  'form.account.work.status': '请选择就业状态',
  'form.account.input.work.status': '请输入就业情况',
  'form.account.choose.edu': '请选择教育程度',
  'form.account.choose.asset': '请选择总资产',
  'form.account.choose.income': '请选择年收入',
  'form.account.choose.target': '请选择投资目标',
  'form.account.choose.experience': '请选择投资经验',
  'form.account.choose.experienceType': '请选择投资类型',
  'form.account.choose.derivativesKnowledge': '请选择衍生品知识',
  'form.account.choose.hasKnowledge': '请选择衍生工具知识',
  'form.account.choose.riskTolerance': '风险承受能力项不符合监管要求，您将不能开户',
  'form.account.houseSituation': '住房情况',
  'form.account.valuation': '估值（扣除按揭）',
  'form.account.valuation.placeholder': '请填写估值',
  'form.account.work.label1': '雇主姓名',
  'form.account.work.label1.placeholder': '请输入雇主姓名',
  'form.account.work.label2': '职业/职务',
  'form.account.work.label2.placeholder': '请输入职业/职务',
  'form.account.work.label3': '任职年期',
  'form.account.work.label3.placeholder': '请输入任职年期',
  'form.account.work.label4': '职位',
  'form.account.work.label4.placeholder': '请输入职位',
  'form.account.work.label5': '业务性质',
  'form.account.work.label5.placeholder': '请输入业务性质',
  'form.account.investmentExperience': '投资类型',
  'form.account.derivativesKnowledge': '衍生品知识',
  'form.account.derivativesKnowledge0': '如何了解有关衍生工具知识',
  'form.account.name.prefix.address': '居住地址',
  'form.account.name.placeholder.input.address': '请输入居住地址',
  'account.open.form.work.status': '就业状态',
  'account.open.form.work.hire': '受雇',
  'account.open.form.work.hire.self': '自雇',
  'account.open.form.work.other': '其它',
  'account.open.education.status': '教育程度',
  'account.open.education.status.primary': '小学或以下',
  'account.open.education.status.middle': '中学',
  'account.open.education.status.college': '大专',
  'account.open.education.status.undergraduate': '本科或以上',
  'account.open.asset.status': '总资产',
  'account.open.asset.status30': '< 30万',
  'account.open.asset.status100': '30万-100万',
  'account.open.asset.status500': '100万-500万',
  'account.open.asset.status.more': '>500万',
  'account.open.asset.year.status': '年收入',
  'account.open.asset.year.status10': '< 10万',
  'account.open.asset.year.status30': '10万-30万',
  'account.open.asset.year.status500': '30万-500万',
  'account.open.asset.year.status.more': '>500万',
  'account.open.invest.target': '投资目标',
  'account.open.invest.target.no.lose': '保本',
  'account.open.invest.target.share': '分红',
  'account.open.invest.target.all': '投资/投机',
  'account.open.invest.experience': '投资经验',
  'account.open.invest.experience.no': '没有',
  'account.open.invest.experience.soso': '一般',
  'account.open.invest.experience.much': '丰富',
  'account.open.affordability.status': '风险承受能力',
  'account.open.taffordability.status.no': '不能容忍亏损',
  'account.open.taffordability.status.low': '低(亏5-10%)',
  'account.open.taffordability.status.mid': '中(亏10-20%)',
  'account.open.taffordability.status.high': '高(亏20%以上)',
  'account.open.quit.message': '确定退出开户流程吗？',
  'face.name.11': '完成认证',


}
